import React from 'react'
import classNames from 'classnames'

import { H1 } from './typography'
import { BulletList } from './list'
import Link, { Button } from './link'
import * as classes from '../styles/offer.module.sass'

function makeSendOwlLink(ids, type = 'packages') {
    return `https://transactions.sendowl.com/${type}/${ids[0]}/${ids[1]}/add_to_cart`
}

export const Offer = ({
    color,
    title,
    subtitle,
    features = [],
    orderText,
    price,
    priceInfo,
    sendowl,
    renew,
}) => {
    return (
        <article className={classes.root} style={{ '--color-theme': color }}>
            <header className={classes.header}>
                <H1 Component="h2" className={classes.title}>
                    {title}
                </H1>
                {subtitle && <p className={classes.subtitle}>{subtitle}</p>}
            </header>
            <div className={classes.content}>
                <BulletList className={classes.list}>
                    {features.map((feat, i) => (
                        <li key={i}>{feat}</li>
                    ))}
                </BulletList>
                <footer className={classes.footer}>
                    {price && (
                        <div className={classes.price}>
                            <span className={classes.priceValue}>
                                ${price} <sub className={classes.priceMeta}>USD</sub>
                            </span>
                            {priceInfo && (
                                <div className={classes.priceMeta}>{priceInfo} (excl. tax)</div>
                            )}
                        </div>
                    )}

                    <Button className="sendowl-button" large primary to={makeSendOwlLink(sendowl)}>
                        {orderText || 'Buy now'}
                    </Button>

                    {renew && (
                        <Link
                            to={makeSendOwlLink(renew.sendowl, 'products')}
                            className={classNames('sendowl-button', classes.renew)}
                            hidden
                        >
                            <strong>{renew.title}</strong>
                            <br />
                            {renew.text}
                        </Link>
                    )}
                </footer>
            </div>
        </article>
    )
}

export const OfferBanner = ({ title, subtitle, text, buttonUrl, buttonText, className }) => {
    return (
        <article className={classNames(classes.banner, className)}>
            <header className={classes.bannerColumn}>
                <H1 Component="h2" className={classes.bannerTitle}>
                    <nobr>{title}</nobr>
                </H1>
                {subtitle}
            </header>
            <p className={classes.bannerColumn}>{text}</p>
            <footer>
                <Button large to={buttonUrl}>
                    {buttonText}
                </Button>
            </footer>
        </article>
    )
}
